exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-sign {\n  width: 100%;\n}\n.page-sign .vux-tab .vux-tab-item {\n  background: #e1e1e1;\n  color: #47b467;\n}\n.page-sign .vux-tab .vux-tab-item.vux-tab-selected {\n  background: #47b467;\n  color: #fff;\n}\n.page-sign .vux-tab-ink-bar {\n  display: none !important;\n}\n.page-sign .my-menu {\n  position: relative;\n  height: calc(100vh - 30px);\n}\n.page-sign .list-empty {\n  height: 400px;\n  padding: 100px 0;\n  text-align: center;\n  color: #a2a2a2;\n}\n.page-sign .list-empty i {\n  font-size: 50px;\n}\n.page-sign .list-empty span {\n  display: block;\n}\n", ""]);

// exports
